module.exports = __webpack_public_path__ + "img/KC.b5ce236d.png";